import axios from 'axios';
/**
 * LOAD DATA
 * set Axios Wrapper API Base End Point
 */

let apiIoffice = process.env.VUE_APP_IOFFICE_API;

export const AuthLogout = axios.create({
    baseURL: apiIoffice,
});

export const AuthLogin = axios.create({
    baseURL: apiIoffice,
});

AuthLogout.interceptors.request.use(
    config => {
        config.headers = {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
            'appsource': 'ioffice',
            'Content-Type': 'multipart/form-data'
        }
        return config;
    },
    error => Promise.reject(error)
);